import React from 'react';
import { ArrowRight } from 'lucide-react';
import { results } from '../../data/mockData';

const Results = () => {
  return (
    <section id="results" className="py-24 md:py-32 bg-[#0a0a0a] text-white">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Section title */}
        <div className="mb-16 md:mb-24">
          <h2 className="text-[clamp(3rem,8vw,8rem)] font-light text-gray-800 leading-none tracking-tight">
            <span className="block">OUR</span>
            <span className="block ml-[10%]">RESULTS</span>
          </h2>
        </div>

        {/* Results grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {results.map((result) => (
            <div key={result.id} className="group">
              <div className="mb-4">
                <span className="text-5xl md:text-6xl lg:text-7xl font-light text-white">
                  {result.metric}
                </span>
              </div>
              <p className="text-gray-400 mb-4 leading-relaxed">
                {result.description}
              </p>
              <a
                href="#"
                className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-white transition-colors duration-300"
              >
                View Project <ArrowRight size={14} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Results;
